<template>
	<div
		class="flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100"
	>
		<h1
			class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate"
		>
			Passwort zurücksetzen
		</h1>
		<form
			class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg"
		>
			<div class="mb-4">
				<label
					class="block font-medium text-sm text-gray-700"
					for="newPassword"
				>
					Neues Passwort
				</label>
				<form-input
										id="newPassword"
										type="input"
										inputType="password"
										class="mt-1 block w-full"
										v-model="data.newPassword"
										autofocus
									></form-input>
									<error-field
										:message="errors.newPassword"
										v-if="errors.newPassword"
									/>
			</div>
			<div class="mb-6">
				<label
					class="block font-medium text-sm text-gray-700"
					for="newPasswordCheck"
				>
					Neues Passwort wiederholen
				</label>
				<form-input
										id="newPasswordCheck"
										type="input"
										inputType="password"
										class="mt-1 block w-full"
										v-model="data.newPasswordCheck"
										autofocus
									></form-input>
									<error-field
										:message="errors.newPasswordCheck"
										v-if="errors.newPasswordCheck"
									/>
			</div>
			<div class="flex items-center justify-end">
				<form-button
					:type="button"
					:button="secondary"
					@click.prevent="resetPassword"
				>
					Passwort zurücksetzen
				</form-button>
			</div>
		</form>
	</div>
</template>

<script>
	import UserService from "@/services/user.js";
	import FormButton from "@/components/FormButton";
	import FormInput from "@/components/FormInput";
	import ErrorField from "@/components/ErrorField";
	import { useRoute } from 'vue-router';

	export default {
		components: {
			FormButton,
			FormInput,
			ErrorField
		},
		data() {
			return {
				data: {
					newPassword: "",
					newPasswordCheck: "",
					userId: "",
					resetToken: ""
				},
				errors: {}
			};
		},
		async created() {
			if (this.$store.getters.isLoggedIn) {
				this.$router.push("/url/overview");
			}

			const route = useRoute();
			this.data.userId = route.params.userId;
			this.data.resetToken = route.params.resetToken;
		},
		methods: {
			async resetPassword() {
				if (this.data.newPassword != this.data.newPasswordCheck) {
					this.errors.newPasswordCheck = "Die beiden eingegebenen Passwörter stimmen nicht überein";
					return;
				} else {
					this.errors.newPasswordCheck = null;
				}

				this.$emit("update-loading-overlay", true);
				try {
					this.$emit("update-loading-overlay", true);

					const response = await UserService.resetPassword(this.data);
					if (response.success == 1) {
						this.$emit("show-toast", {
							message: response.message,
							type: "success",
						});
						this.$emit("update-loading-overlay", false);
						this.$router.push(response.redirect);
					} else {
						this.$emit("show-toast", {
							message: response.message,
							type: "error",
						});
						this.$emit("update-loading-overlay", false);
						this.$router.push(response.redirect);
					}
				} catch (error) {
					console.log(error);
					this.$emit("update-loading-overlay", false);
				}
			},
		},
	};
</script>
